import { AllocationBasisByRuleGraphVersionTable } from "features/fund-family/setup/fund-structure/AllocationBasisByRuleGraphVersionTable";
import { AllocationRuleGraphTabProps } from "features/fund-family/setup/fund-structure/AllocationRuleGraphPage";
import { useAllocationRuleGraphVersionTableDataRetrieveSuspense } from "gen/endpoints/allocation-rule-graph/allocation-rule-graph";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const AllocationRuleGraphTabBasis: React.FC = () => {
  const { fundFamilyId, ruleGraphUseId } =
    useOutletContext<AllocationRuleGraphTabProps>();

  const { allocationRuleGraphId } = useRequiredStringParams();

  const { t } = useTranslation(["common", "allocation"]);

  const { data: tableData } =
    useAllocationRuleGraphVersionTableDataRetrieveSuspense(
      fundFamilyId,
      allocationRuleGraphId,
      {
        allocation_rule_graph_use_id: ruleGraphUseId,
      },
    );

  return (
    <PageTabBody>
      <TableBox>
        <TableBoxHeader>
          <TableBoxTitle>{t("allocation:ruleVersions")}</TableBoxTitle>
        </TableBoxHeader>
        <TableBoxBody>
          <DataTable data={tableData} showAllRows={true} fillWidth={true} />
        </TableBoxBody>
      </TableBox>
      <AllocationBasisByRuleGraphVersionTable
        fundFamilyId={fundFamilyId}
        ruleGraphId={allocationRuleGraphId}
        title={t("allocation:ruleGraphBasis.commitmentsTableTitle")}
      />
    </PageTabBody>
  );
};
